import React, { useState, useEffect } from 'react';
import { Select, Button, message, Popconfirm } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { dashboardStorage } from '../../services/dashboardStorage';
import { useTheme } from '../../context/ThemeContext';

const { Option } = Select;

const DashboardSelector = ({ currentDashboard, onSelect, onCreateNew, refreshKey = 0 }) => {
  const { isDark } = useTheme();
  const [dashboards, setDashboards] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load dashboard list on mount and when refreshKey changes (e.g. after save)
  useEffect(() => {
    loadDashboards();
  }, [refreshKey]);

  const loadDashboards = async () => {
    setLoading(true);
    try {
      const list = await dashboardStorage.list();
      setDashboards(list);
    } catch (error) {
      message.error('Failed to load dashboards');
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (dashboardName) => {
    onSelect(dashboardName);
  };

  const handleDelete = async () => {
    if (!currentDashboard) return;

    try {
      const result = await dashboardStorage.delete(currentDashboard);
      if (result.success) {
        message.success('Dashboard deleted');
        loadDashboards(); // Refresh list
        onSelect(null); // Clear selection
      } else {
        message.error('Failed to delete dashboard');
      }
    } catch (error) {
      message.error('Error deleting dashboard');
    }
  };

  return (
    <>
      <Select
        value={currentDashboard}
        onChange={handleSelect}
        style={{ minWidth: 180 }}
        loading={loading}
        placeholder="Select dashboard"
        dropdownRender={menu => (
          <>
            {menu}
            <div style={{ 
              padding: '8px', 
              borderTop: isDark ? '1px solid #30363d' : '1px solid #f0f0f0' 
            }}>
              <Button
                type="dashed"
                icon={<PlusOutlined />}
                onClick={onCreateNew}
                style={{ 
                  width: '100%',
                  borderColor: isDark ? '#30363d' : '#d9d9d9',
                  color: isDark ? '#8b949e' : '#595959'
                }}
              >
                Create New
              </Button>
            </div>
          </>
        )}
        dropdownStyle={{
          background: isDark ? '#161b22' : '#fff',
        }}
      >
        {dashboards.map(dashboard => (
          <Option key={dashboard.name} value={dashboard.name}>
            {dashboard.title || dashboard.name}
          </Option>
        ))}
      </Select>

      {/* Delete button - outside dropdown */}
      {currentDashboard && (
        <Popconfirm
          title="Delete Dashboard"
          description={`Are you sure you want to delete "${currentDashboard}"?`}
          onConfirm={handleDelete}
          okText="Delete"
          cancelText="Cancel"
          okButtonProps={{ danger: true }}
        >
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            style={{ marginLeft: 4 }}
          >
            Delete
          </Button>
        </Popconfirm>
      )}

    </>
  );
};

export default DashboardSelector;